<template>
  <div class="main">
    <c-panel>
      <h3 class="u-mb-10">Restrições alimentares do aluno</h3>

      <el-alert class="u-mb-20" type="warning" :closable="false" show-icon
        title="Dado de saúde. Registrado por profissional com função clínica e usado para montar a dieta e conferir o cardápio."></el-alert>

      <el-row :gutter="10" class="u-mb-20">
        <el-col :xs="24" :sm="16">
          <el-select v-model="alunoId" filterable remote reserve-keyword placeholder="Digite o nome do aluno"
                     :remote-method="buscarAluno" :loading="buscando" style="width:100%" @change="carregar">
            <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="8" class="u-text-right">
          <el-button type="primary" :disabled="!alunoId || !podeEscrever" @click="abrirNova">NOVA RESTRIÇÃO</el-button>
        </el-col>
      </el-row>

      <div v-if="erro">
        <el-alert :title="erro" type="warning" :closable="false" show-icon></el-alert>
      </div>

      <div class="container-table" v-if="carregado && !erro">
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width:120px;">Tipo</th>
              <th>Restrição</th>
              <th style="width:130px;">Severidade</th>
              <th class="hidden-mobile">Orientação</th>
              <th style="width:140px;">Origem</th>
              <th style="width:90px;" class="u-text-center" v-if="podeEscrever">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in restricoes" :key="i">
              <td>{{ r.tipo.toUpperCase() }}</td>
              <td><strong>{{ r.alvo }}</strong></td>
              <td>{{ r.severidade }}</td>
              <td class="hidden-mobile u-fs-12">{{ r.orientacao || '—' }}</td>
              <td>
                <el-tag size="mini" :type="r.origem === 'estruturada' ? 'success' : 'info'">
                  {{ r.origem === 'estruturada' ? 'estruturada' : 'catálogo de alergias' }}
                </el-tag>
              </td>
              <td class="u-text-center" v-if="podeEscrever">
                <el-button v-if="r.id" @click="excluir(r.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                <span v-else class="u-fs-12" title="Vem do catálogo de alergias do aluno">—</span>
              </td>
            </tr>
            <tr v-if="restricoes.length === 0">
              <td :colspan="podeEscrever ? 6 : 5" class="u-text-center">Nenhuma restrição registrada.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-dialog title="Nova restrição alimentar" :visible.sync="dialogo" width="560px">
        <el-form :model="nova" label-position="top">
          <el-form-item label="Tipo">
            <el-select v-model="nova.tipo" @change="nova.alimento_id = ''; nova.nutriente_id = ''; nova.alergia_id = ''" style="width:100%">
              <el-option label="Ingrediente" value="ingrediente"></el-option>
              <el-option label="Nutriente" value="nutriente"></el-option>
              <el-option label="Alergia (catálogo)" value="alergia"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Ingrediente" v-if="nova.tipo === 'ingrediente'">
            <el-select v-model="nova.alimento_id" filterable remote reserve-keyword placeholder="Buscar ingrediente"
                       :remote-method="buscarAlimento" :loading="buscandoAlimento" style="width:100%">
              <el-option v-for="a in alimentos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Nutriente" v-if="nova.tipo === 'nutriente'">
            <el-select v-model="nova.nutriente_id" filterable style="width:100%">
              <el-option v-for="n in nutrientes" :key="n.id" :label="n.nome + ' (' + n.unidade + ')'" :value="n.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Alergia" v-if="nova.tipo === 'alergia'">
            <el-select v-model="nova.alergia_id" filterable style="width:100%">
              <el-option v-for="a in alergias" :key="a.id" :label="a.nome" :value="a.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Severidade">
            <el-select v-model="nova.severidade" style="width:100%">
              <el-option label="Intolerância" value="intolerancia"></el-option>
              <el-option label="Alergia" value="alergia"></el-option>
              <el-option label="Preferência" value="preferencia"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Orientação / conduta">
            <el-input v-model="nova.orientacao" type="textarea" :rows="3"></el-input>
          </el-form-item>

          <el-form-item label="Nutricionista responsável">
            <el-select v-model="nova.nutricionista_id" filterable clearable style="width:100%">
              <el-option v-for="n in nutricionistas" :key="n.id" :label="n.nome_exibicao" :value="n.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <span slot="footer">
          <el-button @click="dialogo = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="primary" @click="salvar">SALVAR</el-button>
        </span>
      </el-dialog>
    </c-panel>
  </div>
</template>

<script>
export default {
  data: () => ({
    alunoId: '', alunos: [], buscando: false,
    restricoes: [], carregado: false, erro: '',
    dialogo: false,
    alimentos: [], buscandoAlimento: false,
    nutrientes: [], alergias: [], nutricionistas: [],
    nova: { tipo: 'ingrediente', alimento_id: '', nutriente_id: '', alergia_id: '', severidade: 'intolerancia', orientacao: '', nutricionista_id: '' }
  }),
  computed: {
    // Reflete a matriz do backend, que é quem decide de fato.
    podeEscrever () { return [4, 5, 6].indexOf(Number(this.$store.state.user.tipo)) !== -1 }
  },
  mounted () { this.carregarApoio() },
  methods: {
    carregarApoio () {
      const h = this.$store.getters.getHeaderAuth
      const base = this.$store.state.config.baseUrlApi
      this.$axios.get(`${base}/api/merenda/nutriente/getAll`, h).then(r => { this.nutrientes = r.data }).catch(() => {})
      this.$axios.get(`${base}/api/merenda/nutricionista/getAll`, h).then(r => { this.nutricionistas = r.data }).catch(() => {})
      this.$axios.post(`${base}/api/alergia/getAllPaginate`, { per_page: 200 }, h)
        .then(r => { this.alergias = r.data.data || r.data }).catch(() => {})
    },
    buscarAluno (q) {
      if (!q || q.length < 3) { this.alunos = []; return }
      this.buscando = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
        .then(r => { this.alunos = Array.isArray(r.data) ? r.data : (r.data.data || []); this.buscando = false })
        .catch(() => { this.buscando = false; this.alunos = [] })
    },
    buscarAlimento (q) {
      if (!q || q.length < 2) { this.alimentos = []; return }
      this.buscandoAlimento = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
        .then(r => { this.alimentos = Array.isArray(r.data) ? r.data : (r.data.data || []); this.buscandoAlimento = false })
        .catch(() => { this.buscandoAlimento = false; this.alimentos = [] })
    },
    carregar () {
      if (!this.alunoId) return
      this.erro = ''; this.carregado = false
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/restricao-alimentar/aluno/` + this.alunoId, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) { this.erro = r.data.erro; this.restricoes = []; return }
          this.restricoes = r.data.restricoes || []
          this.carregado = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    abrirNova () {
      this.nova = { tipo: 'ingrediente', alimento_id: '', nutriente_id: '', alergia_id: '', severidade: 'intolerancia', orientacao: '', nutricionista_id: '' }
      this.dialogo = true
    },
    salvar () {
      const payload = Object.assign({ aluno_id: this.alunoId }, this.nova)
      window.eventBus.$emit('loading', true)
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/restricao-alimentar/store`, payload, this.$store.getters.getHeaderAuth)
        .then(r => {
          window.eventBus.$emit('loading', false)
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.dialogo = false
          this.carregar()
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    excluir (id) {
      this.$msgbox.confirm('Excluir esta restrição?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/restricao-alimentar/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(r => {
              window.eventBus.$emit('loading', false)
              if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              this.carregar()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => {})
    }
  }
}
</script>
